module.exports = __webpack_public_path__ + "img/mail.046a4f28.svg";